import { Link, Typography } from "@mui/material";
import React, { useState } from "react";

import useShopContext from "@hooks/useShopContext";
import { Box, Stack } from "@mui/system";

const TextElement = ({ title, description, image_url }) => {
  const { shop } = useShopContext();
  const [more, setMore] = useState(false);

  const shouldEllipsis = description?.length > 150;
  const ellipsisDescription = description?.substring(0, 150) + "...";

  return (
    <Stack sx={{ textAlign: "center", my: 1 }} gap={0.5} alignItems="center">
      {title ? <Typography fontWeight={500}>{title}</Typography> : null}
      {image_url ? (
        <Box
          component="img"
          src={image_url}
          alt={title}
          sx={{ width: "60%", maxHeight: 300, height: "auto", borderRadius: 4, objectFit: "cover" }}
        />
      ) : null}
      <Typography
        sx={(theme) => ({
          textAlign: "center",
          wordBreak: "break-word",
          whiteSpace: "pre-line",
          overflow: "hidden",
          textOverflow: !more && shouldEllipsis ? "ellipsis" : null,
          display: "-webkit-box",
          WebkitLineClamp: !more && shouldEllipsis ? 3 : null,
          WebkitBoxOrient: "vertical",
          color: shop?.text_color || theme.palette.primary.contrastText,
        })}
      >
        {!more && shouldEllipsis ? ellipsisDescription : description}
      </Typography>
      {shouldEllipsis && (
        <Link
          component="button"
          sx={(theme) => ({
            color: shop?.text_color || theme.palette.primary.contrastText,
            fontStyle: "italic",
          })}
          underline="always"
          variant="body2"
          onClick={() => setMore(!more)}
        >
          View {more ? "less" : "more"}
        </Link>
      )}
    </Stack>
  );
};

export default TextElement;
